import { FETCH_DATA_FAILURE, FETCH_DATA_SUCCESS, LOGIN_FAILURE, LOGIN_SUCCESS, LOGOUT } from 'features/user/userTypes';
import { getDefaultAppliedFilters, getEmptyAppliedFilters, normalizeAppliedFilters } from './globalFiltersStorage';

const GLOBAL_FILTERS_PREFIX = 'GLOBAL_FILTERS_';
export const SET_FILTERS = GLOBAL_FILTERS_PREFIX + 'SET_FILTERS';
export const RESET_FILTERS = GLOBAL_FILTERS_PREFIX + 'RESET_FILTERS';
export const SET_NOT_APPLIED_FILTERS = GLOBAL_FILTERS_PREFIX + 'SET_NOT_APPLIED_FILTERS';
export const SET_TABLEAU_APPLIED_FILTER_VALUES = GLOBAL_FILTERS_PREFIX + 'SET_TABLEAU_APPLIED_FILTER_VALUES';
export const SET_DEFAULTS_SEEDED = GLOBAL_FILTERS_PREFIX + 'SET_DEFAULTS_SEEDED';

const initialState = {
  applied: getDefaultAppliedFilters(),
  notAppliedFilters: [],
  tableauAppliedFilterValues: {},
  defaultsSeeded: false
};

export const setGlobalFilters = (filters) => ({
  type: SET_FILTERS,
  payload: filters
});

export const resetGlobalFilters = () => ({
  type: RESET_FILTERS
});

export const setNotAppliedFilters = (filters) => ({
  type: SET_NOT_APPLIED_FILTERS,
  payload: filters
});

export const setTableauAppliedFilterValues = (filterValues) => ({
  type: SET_TABLEAU_APPLIED_FILTER_VALUES,
  payload: filterValues
});

export const setDefaultsSeeded = (seeded) => ({
  type: SET_DEFAULTS_SEEDED,
  payload: seeded
});

const getResetState = () => ({
  applied: getDefaultAppliedFilters(),
  notAppliedFilters: [],
  tableauAppliedFilterValues: {},
  defaultsSeeded: false
});

// State for a tenant with filters disabled: no filter values set at all, and
// no seeding required (gate is opened so metrics load without filters).
const getFiltersDisabledState = () => ({
  applied: getEmptyAppliedFilters(),
  notAppliedFilters: [],
  tableauAppliedFilterValues: {},
  defaultsSeeded: true
});

const currentTenantFiltersEnabled = (payload) => {
  const currentTenant = payload?.companies?.find((company) => company.code === payload?.currentTenantCd);
  return currentTenant?.filtersEnabled !== false;
};

const globalFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTERS:
      return {
        ...state,
        applied: {
          ...state.applied,
          ...normalizeAppliedFilters(action.payload)
        }
      };
    case SET_NOT_APPLIED_FILTERS:
      return {
        ...state,
        notAppliedFilters: action.payload
      };
    case SET_TABLEAU_APPLIED_FILTER_VALUES:
      return {
        ...state,
        tableauAppliedFilterValues: {
          ...state.tableauAppliedFilterValues,
          ...action.payload
        }
      };
    case SET_DEFAULTS_SEEDED:
      return {
        ...state,
        defaultsSeeded: action.payload
      };
    case RESET_FILTERS:
      return getResetState();
    case FETCH_DATA_SUCCESS:
    case LOGIN_SUCCESS:
      return currentTenantFiltersEnabled(action.payload) ? state : getFiltersDisabledState();
    case LOGIN_FAILURE:
    case FETCH_DATA_FAILURE:
    case LOGOUT:
      return getResetState();
    default:
      return state;
  }
};

export default globalFiltersReducer;